<!--
    Tipos de User Input
 -->

 <div [ngSwitch]="itemType" [formGroup]="evaluationFormGroup">
    <!-- Texto Libre -->
    <div *ngSwitchCase="currentItemType.Text" class="form-group row">
        <label class="col-lg-7 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
        <div class="col-lg-5">
            <div [ngClass]="{'error-field-container': evaluationFormGroup.get(evaluationFormControlName)?.errors }">
                <mat-form-field class="mat-form-field-fluid">
                    <input matInput #textInput
                    [formControlName]="evaluationFormControlName">
                    <mat-hint align="end">{{textInput.value.length}} / {{maxLength}}</mat-hint>
                    <!-- errors -->
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
    <!-- Lista   -->
    <div *ngSwitchCase="currentItemType.List" class="form-group row">
        <label class="col-lg-7 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
        <div class="col-lg-5">
            <div [ngClass]="{'error-field-container': evaluationFormGroup.get(evaluationFormControlName)?.errors }" 
                style="height: 85px!important">
                <mat-form-field class="chip-list" style="height: 85px!important">
                    <!--<mat-label>{{'AUTH.MULTIPLE_LINE_FIELD' | translate}}</mat-label>-->
                    <mat-chip-grid #chipList class="mat-chip-grid-stacked"
                                   cdkDropList
                                   cdkDropListOrientation="vertical"
                                   (cdkDropListDropped)="dropItemInList($event, evaluationFormGroup.get(evaluationFormControlName))">
                       <div class="padding" style="display: flex; flex-wrap: wrap;">
                            <mat-chip-row *ngFor="let item of evaluationFormGroup.get(evaluationFormControlName).value"
                            cdkDrag
                            [cdkDragDisabled]="evaluationFormGroup.get(evaluationFormControlName).disabled"
                            cdkDragBoundary="mat-chip-grid"
                            [removable]="evaluationFormGroup.get(evaluationFormControlName).enabled"
                            (removed)="removeItemInList(item, evaluationFormGroup.get(evaluationFormControlName))">
                            {{item}}
                            <mat-icon matChipRemove *ngIf="evaluationFormGroup.get(evaluationFormControlName).enabled">cancel</mat-icon>
                            </mat-chip-row>
             
                            <input #inputElement
                            placeholder="{{'AUTH.MULTIPLE_LINE_FIELD' | translate}}"
                            (focusout)="addItemInList(inputElement.value, inputElement)"
                            [matChipInputFor]="chipList"
                            (matChipInputTokenEnd)="addItemInList($event.value, inputElement)">
                       </div>
                       
                    </mat-chip-grid>
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-hint>
                </mat-form-field>
<!--                <button mat-icon-button><mat-icon>add</mat-icon></button>-->
            </div>
        </div>
    </div>
    <!-- Option selection -->
    <div *ngSwitchCase="currentItemType.SingleDropDownSelection" class="form-group row">
        <label class="col-lg-7 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
        <div class="col-lg-5">
            <div [ngClass]="{'error-field-container': evaluationFormGroup.get(evaluationFormControlName)?.errors }">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label></mat-label>
                    <mat-select
                        [formControlName]="evaluationFormControlName">
                        <mat-option
                            *ngFor="let answer of answers"
                            [value]="answer.id">
                            {{answer.description}}
                        </mat-option>
                    </mat-select>
                    <!-- errors -->
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
    <!-- Radio Button  -->
    <div *ngSwitchCase="currentItemType.RadioButton" class="form-group row">
        <label class="col-lg-7 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
        <mat-radio-group class="col-lg-5 radio-group-control" [formControlName]="evaluationFormControlName">
            <mat-radio-button
                *ngFor="let answer of answers"
                [value]="answer.id">
                {{answer.description}}
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <!-- Multiple Select  -->
    <div *ngSwitchCase="currentItemType.MultipleDropDownSelection" class="form-group">
        <div class="row">
            <label class="col-lg-12 col-form-label">
                {{label}}
                <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
            </label>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div [ngClass]="{'error-field-container': evaluationFormGroup.get(evaluationFormControlName)?.errors }">
                    <mat-form-field class="mat-form-field-fluid">
                        <!-- <h1>{{ evaluationFormGroup.get(evaluationFormControlName).value | json}}</h1>  -->

                        <mat-select [formControlName]="evaluationFormControlName" class="multiple-selection"
                            (selectionChange)="removeMultipleSelectionNullValue()" multiple>
                            <!-- Display format when closed -->
                            <mat-select-trigger>
                                <div *ngFor="let selectedItem of evaluationFormGroup.get(evaluationFormControlName).value" class="multiple-selection-item">
                                    <div *ngIf="selectedItem.id != null">
                                        <i class="material-icons md-24" style="margin-right: 0.3em;">check_box</i>
                                        <span>{{ selectedItem.description | trim}}</span>
                                    </div>
                                    <div *ngIf="selectedItem.id == null">
                                        <i class="material-icons md-24" style="margin-right: 0.3em;">close</i>
                                        <span>{{ 'EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION' | translate }}</span>
                                    </div>
                                </div>
                            </mat-select-trigger>

                            <mat-option *ngFor="let answer of answers" [value]="answer.id">
                                {{answer.description}}
                            </mat-option>
                            <mat-option [value]="getNoSelectionItem()" [disabled]="!nullSelectionEnabled()">
                                {{ 'EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION' | translate }}
                            </mat-option>
                        </mat-select>

                        <!-- errors -->
                        <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <!-- Due Diligence Option selection -->
    <div *ngSwitchCase="currentItemType.DueDiligenceSingleOptionSelection" class="form-group row">
        <label class="col-lg-7 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
        <mat-radio-group class="col-lg-5 radio-group-control" [formControlName]="evaluationFormControlName">
            <mat-radio-button *ngFor="let answer of answers" [value]="answer.id">
                <i class="flaticon2-hexagonal due-diligence-option-selection"
                    [style.color]="'#' + answer.description">
                </i>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <!-- Due Diligence Feature Item (Files) -->
    <div *ngSwitchCase="currentItemType.DueDiligenceFeatureItem" class="form-group row">
        <label class="col-lg-7 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
    </div>

    <!-- Record Type Column -->
    <div *ngSwitchCase="currentItemType.RecordAnswer" class="form-group row">
        <label class="col-lg-12 col-form-label">
            {{label}}
            <div class="explanation">{{ explanation? ( '({0})' | stringFormat: explanation) : null }}</div>
        </label>
        <kt-record-type-question
            class="col-lg-12 container"
            #recordTypeQuestion
            [exploreMode]="disabledButtons"
            [evaluationFormItem]="evaluationFormItem"
            [formAnswers]="formAnswers"
            [evaluationFormGroup]="evaluationFormGroup"
            [evaluationFormControlName]="evaluationFormControlName">
        </kt-record-type-question>    
    </div>
    <div class="row" style="align-items: center;">

        <div class="row col-lg-7 justify-content-lg-center">
            <!--*ngIf="enableConversationFeature()"-->
            <div *ngIf="(showConversation || conversation$.getValue().length > 0 || forceShowConversation)"
                class="col-lg-6 feature-item-button">
                <!--!protectedMode && !forceShowConversation-->
                <kt-conversation-manager
                    [protectedMode]="disableConversation"
                    [matTooltip]="'EVALUATION.TOOLTIP.DISPLAY_CONVERSATION' | translate"
                    [icon]="'flaticon2-chat'"
                    [contextId]="_itemAnswerId$ | async"
                    [currentAnswerId]="currentAnswerId"
                    [conversationItems]="conversation$ | async"
                    (message)="enqueueMessageItem($event)"
                    [conversationItemClass]="conversationItemClass"
                    (messageDequeue)="dequeueMessageItem($event)">
                </kt-conversation-manager>
            </div>

            <div *ngIf="enableFileUploadFeature()"
                class="col-lg-6 feature-item-button">
                
                <!-- [protectedMode]="!canUploadFiles()" -->
                <kt-file-uploader                   
                    [evaluationFiles]="_evaluationFormFiles$ | async"
                    [contextId]="protectedMode ? true : !disabledButtons"
                    [isDetail]="protectedMode || evaluationFormGroup.disabled || noSelectionItem"
                    [answerId]="(_itemAnswerId$ | async)"
                    [dueDiligenceMode]="!evaluationContextId"
                    [initialFiles]="initialFiles"
                    [fileDownloadFnc]="fileDownloadFnc"
                    (fileUpload)="enqueueFileItem($event)"
                    (fileDequeue)="dequeueFileItem($event)"
                    [evaluationItemType]="itemType"
                    [lastAnswerId]="lastAnswerId">
                </kt-file-uploader>
            </div>
        </div>

        <div *ngIf="commentAvailable && (!exploreMode || disabledButtons || evaluationFormGroup.get(evaluationFormControlName+'-comment').dirty)"
            [ngClass]="{'offset-lg-7': !enableConversationFeature() && !enableFileUploadFeature(),'col-lg-5': true}">

            <div [ngClass]="{'error-field-container': evaluationFormGroup.get(evaluationFormControlName+'-comment').errors }">
                <mat-form-field [ngClass]="{'mat-form-field-fluid': true}">
                    <input matInput #textInput
                        [placeholder]="(!exploreMode? 'EVALUATION.COMMENT' : 'EVALUATION.ADD_COMMENT') | translate"
                        [formControlName]="evaluationFormControlName+'-comment'"
                        [required]="requiredComments">
                    <mat-hint align="end">{{textInput.value.length}} / {{maxCommentLength}}</mat-hint>
                    <!-- errors -->
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName+'-comment').errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxCommentLength}} &nbsp;</mat-hint>
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName+'-comment').errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName+'-comment').errors?.minlength">{{'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate | stringFormat: minCommentLength}} &nbsp;</mat-hint>
                    <mat-hint class="item-error-msg" *ngIf="evaluationFormGroup.get(evaluationFormControlName+'-comment').errors?.blankSpaces">{{'AUTH.VALIDATION.BLANK_FIELD' | translate }} &nbsp;</mat-hint>
                    <mat-hint class="item-error-msg" *ngIf="requiredComments">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>





